import React from 'react';
import EmailIcon from '@mui/icons-material/Email';
import PhoneIcon from '@mui/icons-material/Phone';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer-container">
      <div className="footer-content">
        <div className="footer-main">
          <div className="footer-logo-section">
            <img 
              src="/logos/logo-laranja.png" 
              alt="Clube do Banho" 
              className="footer-logo"
            />
            <p className="footer-slogan">
              Banho na rotina certa, <br /> sem dor de cabeça.
            </p>
          </div>
          
          <div className="footer-links">
            <div className="footer-column">
              <h3 className="footer-column-title">Para Você</h3>
              <ul className="footer-column-list">
                <li><a href="#baixar-app" className="footer-link">Baixar o App</a></li>
                <li><a href="#encontrar-parceiros" className="footer-link">Encontrar Parceiros</a></li>
                <li><a href="#como-funciona" className="footer-link">Como Funciona</a></li>
              </ul>
            </div>
            
            <div className="footer-column">
              <h3 className="footer-column-title">Para Parceiros</h3>
              <ul className="footer-column-list">
                <li><a href="#seja-parceiro" className="footer-link">Seja Parceiro</a></li>
                <li><a href="#cadastrar-negocio" className="footer-link">Cadastrar Negócio</a></li>
                <li><a href="#login" className="footer-link">Login</a></li>
              </ul>
            </div>
            
            <div className="footer-column">
              <h3 className="footer-column-title">Contato</h3>
              <ul className="footer-column-list">
                <li className="footer-contact-item">
                  <EmailIcon className="footer-icon" />
                  <a href="mailto:contato@clubedobanho.com.br" className="footer-link">
                    contato@clubedobanho.com.br
                  </a>
                </li>
                <li className="footer-contact-item">
                  <PhoneIcon className="footer-icon" />
                  <a href="tel:+551199990000" className="footer-link">
                    (11) 9999-0000
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        
        <div className="footer-bottom">
          <p className="footer-copyright">
            © 2025 Clube do Banho. Todos os direitos reservados.
          </p>
          <div className="footer-legal">
            <a href="#privacidade" className="footer-legal-link">Política de Privacidade</a>
            <a href="#termos" className="footer-legal-link">Termos de Uso</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;

